const { is } = require("@uirouter/angularjs");

(() => {
  angular
    .module('finance')
    .controller(
      'finance.views.debugTools.exportBillingAccountsToNetSuiteModal',
      ExportBillingAccountsToNetSuiteModalController
    );

  ExportBillingAccountsToNetSuiteModalController.$inject = [
    '$uibModalInstance',
    'abp.services.finance.debugTools',
  ];

  function ExportBillingAccountsToNetSuiteModalController(
    $uibModalInstance, 
    debugToolsSvc
  ) {
    const vm = this;
    
    vm.saving = 0;

    vm.exportToNetSuite = exportToNetSuite;
    vm.cancel = cancel;

    function exportToNetSuite() {
      if (!App.isFormValid(vm.exportBillingAccountsToNetSuiteForm)) return;

      vm.saving += 1;
      debugToolsSvc
        .exportBillingAccountsToNetSuite({
          maxCount: vm.maxCount,
          chunkSize: vm.chunkSize,
          delay: vm.delay,
          isPanelDebtorOnly: vm.isPanelDebtorOnly
        })
        .success(() => {
          abp.notify.success(App.localize('Queued'));
        })
        .finally(() => {
          $uibModalInstance.close();
        });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
